// Change Tab Title when not Active
window.addEventListener("load", function() {
  var pageTitle = document.title;
  var attentionMessage = 'Hast du was vergessen? 🧊';

  document.addEventListener('visibilitychange', function(e) {
    var isPageActive = !document.hidden;

    if(!isPageActive){
      document.title = attentionMessage;
    }else {
      document.title = pageTitle;
    }
  });
});

// Body Background Color Change Password Page
window.addEventListener('scroll', () => {
  const body = document.querySelector('body');
  if (window.scrollY > 200) {
    body.classList.remove('tw-bg-white'); //tw-bg-[#00222c]
    body.classList.add('tw-bg-white');
  } else {
    body.classList.remove('tw-bg-white');
    body.classList.add('tw-bg-white'); //tw-bg-[#00222c]
  }
});

console.log('Like what you see? Connect with us at https://unlimited.studio 🚀');

// Designed and developed by unlimited.studio – https://unlimited.studio